import classNames from "classnames";
import { ReactComponent as IconShareCount } from "../../assets/ic-share-count.svg";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

const ShareBringNewFansBody = ({
  leftText,
  rightText,
  leftTextParams,
  rightTextParams,
}) => {
  const instructions = [
    { textKey: leftText, params: leftTextParams },
    { textKey: rightText, params: rightTextParams },
  ];

  const { t } = useTranslation("modals");

  return (
    <div className={classNames(styles.body)}>
      <div
        className={classNames(
          "d-flex flex-column justify-content-between share-bring-new-fans-body-content",
          styles.content,
        )}
      >
        {instructions.map(({ textKey, params }, index) => {
          return (
            <div
              key={textKey}
              className={classNames(
                "d-flex align-items-center",
                styles.instructionItem,
              )}
            >
              <div
                className={classNames(
                  "position-relative d-flex align-items-center justify-content-center",
                  styles.instructionItemCount,
                )}
              >
                <IconShareCount className={styles.instructionItemCountIcon} />
                <span className="text-body-1 text-primary">{index + 1}</span>
              </div>
              <span className="text-body-1 text-primary w-100">
                {t(textKey, params)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShareBringNewFansBody;
